import { PermissionGroupMessages, TranslationPermissionGroupMessages } from "../interfaces";

export const messages : TranslationPermissionGroupMessages = {
  [PermissionGroupMessages.generalRegistration]: "Cadastros gerais",
  [PermissionGroupMessages.supply]: "Insumos",
  [PermissionGroupMessages.concreteRecipeFamily]: "Família de traços",
  [PermissionGroupMessages.administration]: "Administração",
  [PermissionGroupMessages.supplyQuality]: "Qualidade dos insumos",
  [PermissionGroupMessages.vehicles]: "Veículos",
  [PermissionGroupMessages.employees]: "Funcionários",
  [PermissionGroupMessages.report]: "Relatório",
  [PermissionGroupMessages.settings]: "Configurações",
  [PermissionGroupMessages.expedition]: "Expedição",
  [PermissionGroupMessages.schedule]: "Programação",
  [PermissionGroupMessages.userRightsControl]: "Controle de direitos do usuário",
  [PermissionGroupMessages.batchPortalMaintenanceView]: "Manut. Visualizar",
  [PermissionGroupMessages.batchPortalMaintenanceEdit]: "Manut. Editar",
  [PermissionGroupMessages.batchPortalMaintenanceExecute]: "Manut. Executar",
  [PermissionGroupMessages.batchPortalAutomationView]: "Autom. Visualizar",
  [PermissionGroupMessages.batchPortalAutomationExecute]: "Autom. Executar",
  [PermissionGroupMessages.batchPortalAutomationAdmin]: "Autom. Admin",
  [PermissionGroupMessages.batchPortalAutomationSuperAdmin]: "Autom. Super Admin",
  [PermissionGroupMessages.dashboard]: "Dashboard",
  [PermissionGroupMessages.laboratory]: "Laboratório"
};